<template>

  <popup :width="width"
         :height="height"
         @close="onPopupCloseClick"
         :animate="animate"
         :closeButton="closeButton"
         :centeredX="centeredX"
         :centeredY="centeredY"
         :marginLeft="marginLeft"
         :marginTop="marginTop"
         :closeButtonType="closeButtonType"
         :closeOnBlur="closeOnBlur"
         :closeOnEsc="closeOnEsc"
         class="alert">

      <div slot="content">

         <span class="header" v-if="header">{{ header }}</span>

         <div v-html="content" class="content-text"></div>

         <div class="buttons-container">
           <template v-if="type == alertTypes.OK">
             <button class="btn" @click="onButtonClick(alertResultTypes.OK)">OK</button>
           </template>
           <template v-if="type == alertTypes.OK_CANCEL">
             <button class="btn btn-danger" @click="onButtonClick(alertResultTypes.CANCEL)">Cancel</button>
             <button class="btn" @click="onButtonClick(alertResultTypes.OK)">OK</button>
           </template>
           <template v-if="type == alertTypes.YES_NO">
             <button class="btn btn-danger" @click="onButtonClick(alertResultTypes.CANCEL)">No</button>
             <button class="btn" @click="onButtonClick(alertResultTypes.OK)">Yes</button>
           </template>
           <template v-if="type == alertTypes.CUSTOM" v-for="button in buttons">
             <button class="btn" @click="onCustomButtonClick(button)" :class="getButtonClassType(button)">{{ button.name }}</button>
           </template>
         </div>

      </div>

  </popup>

</template>

<script>

  import Popup from '../../Common/Popup/Popup.vue';
  import alertResultTypes from '../../../consts/alertResultTypes';

  export default {

    created() {
      this.alertResultTypes = alertResultTypes;
    },

    components: {
      popup: Popup
    },

    props: {
      width: {
        default: 400
      },
      height: {
        default: 80
      },
      centeredX: {
        type: Boolean,
        default: true
      },
      centeredY: {
        type: Boolean,
        default: true
      },
      marginLeft: {
        type: Number,
        default: 0
      },
      marginTop: {
        type: Number,
        default: 0
      },
      closeButton: {
        type: Boolean,
        default: true
      },
      closeButtonType: {
        type: Number,
        default: 1
      },
      content: {
        default: ''
      },
      type: {
        default: 1,
      },
      buttons: {
        type: Array
      },
      animate: {
        type: Boolean,
        default: false
      },
      header: {
        type: String
      },
      buttonClickCallback: {
        type: Function
      },
      closeOnBlur: {
        type: Boolean,
        default: false
      },
      closeOnEsc: {
        type: Boolean,
        default: false
      }
    },

    methods: {

      onPopupCloseClick() {
        this.$emit('close');
      },

      onButtonClick(alertResultType) {
        if (this.buttonClickCallback)
          this.buttonClickCallback();
        this.$emit('buttonClick', alertResultType);
      },

      onCustomButtonClick(button) {
        if (button.onClick)
          button.onClick();
      },

      getButtonClassType(button) {
        switch (button.buttonType) {
          case this.alertButtonTypes.PRIMARY:
            return 'btn-primary';
          case this.alertButtonTypes.SUCCESS:
            return 'btn-success';
          case this.alertButtonTypes.INFO:
            return 'btn-info';
          case this.alertButtonTypes.WARNING:
            return 'btn-warning';
          case this.alertButtonTypes.DANGER:
            return 'btn-danger';
          case this.alertButtonTypes.GREY:
            return 'btn-grey';
          default:
            return '';
        }
      }

    }

  }

</script>

<style lang="scss" scoped>

  @import '../../../style/buttons.scss';

  .alert {

    .header {
      font-weight: bold;
      font-size: 13px;
      float: left;
      position: relative;
      top: -17px;
      left: -10px;
    }

    .content-text {
      font-family: Arial;
      font-size: 15px;
      clear: both;
    }

    .buttons-container {
      text-align: center;
      margin-top: 25px;

      .btn {
        margin-left: 4px;
      }

    }

  }

</style>



// WEBPACK FOOTER //
// src/components/Common/Popup/AlertPopup.vue